import { helpers } from "vuelidate/lib/validators";

export const emailValidator = helpers.regex("emailValidator", /^\S+@\S+\.\S+$/m);

export const multiEmailValidator = (value) => {
  let returnVar = true;  
  if (!value) {
        return returnVar;
      } else {
        var emails = (value.split(";")).filter(item => item);
        emails.forEach(function (email) {
            if(!(/^\S+@\S+\.\S+$/m).test(email.trim())){
              returnVar = false;
            }
        });
        return returnVar;
      }
}